import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { AdvancedReorderItem } from "../advanced-reorder-item";
import { AdvancedReorderHelper } from "../advanced-reorder-helper";

@Component({
  selector: 'item-options',
  templateUrl: './item-options.component.html',
  styleUrls: ['./item-options.component.scss']
})
export class ItemOptionsComponent {
  @Input() helper: AdvancedReorderHelper;
  @Input() item: AdvancedReorderItem;
}